import { Link } from "react-router-dom";
import type { ServerRecord } from "../types";
import { HealthBadge } from "./HealthBadge";
import { AuthenticationStatus } from "./AuthenticationStatus";
import { formatRelativeTime } from "../utils/format";

export function ServerCard({ server }: { server: ServerRecord }) {
  return (
    <div className={`server-card state-${server.health_state}`}>
      <div className="server-card-title">
        <div>
          <div className="server-card-name">{server.display_name}</div>
          <div className="server-card-id mono">{server.id}</div>
        </div>
        <HealthBadge state={server.health_state} />
      </div>

      <div className="server-card-meta">
        <div className="server-card-meta-row">
          <span>Authentication</span>
          <AuthenticationStatus state={server.authentication_state} />
        </div>
        <div className="server-card-meta-row">
          <span>Last heartbeat</span>
          <span>{formatRelativeTime(server.last_heartbeat_at)}</span>
        </div>
        <div className="server-card-meta-row">
          <span>Client version</span>
          <span className="mono">{server.client_version ?? "—"}</span>
        </div>
      </div>

      <div className="btn-row">
        <Link className="btn btn-sm" to={`/servers/${server.id}`}>
          Open server
        </Link>
      </div>
    </div>
  );
}
